import React, { useEffect } from 'react';
import '../styles/GameProgress.css';
import {Link} from "react-router-dom";

export default function GameProgress() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://p.trellocdn.com/embed.min.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div id="about">

                <div className="everything-container">
                    <p>WANNA SEE HOW WE'RE DOING? CHECK OUT OUR TRELLO:</p>
                    <br/><br/>
                    <iframe
                        src="https://trello.com/b/fZRKX7hr.html"
                        frameBorder="0"
                        width="1366"
                        height="720"
                    ></iframe>

                    <div>
                        <br/>
                        <Link to="https://trello.com/b/fZRKX7hr/poly-beats-pc">
                            <button className="gp-menu-button"><span>GO TO TRELLO.COM</span></button>

                        </Link>
                    </div>
                </div>
            </div>
            );
            }
